import { render, staticRenderFns } from "./UserDivisionConfigPanel.vue?vue&type=template&id=2e2d49f8&scoped=true"
import script from "./UserDivisionConfigPanel.vue?vue&type=script&lang=js"
export * from "./UserDivisionConfigPanel.vue?vue&type=script&lang=js"
import style0 from "./UserDivisionConfigPanel.vue?vue&type=style&index=0&id=2e2d49f8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2d49f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e2d49f8')) {
      api.createRecord('2e2d49f8', component.options)
    } else {
      api.reload('2e2d49f8', component.options)
    }
    module.hot.accept("./UserDivisionConfigPanel.vue?vue&type=template&id=2e2d49f8&scoped=true", function () {
      api.rerender('2e2d49f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/list/components/UserDivisionConfigPanel.vue"
export default component.exports